import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
	boards: [],
	selectedBoardId: null,
	steps: [],
	isLoading: false,
	boardsLoaded: false,
	boardsFetchFailed: false,
	boardsRequestVersion: 0,
	boardsAccountId: null,
	preferences: {},
	productsByBoardId: {}, // { boardId: [products] }
	stepTasks: {}, // { stepId: [tasks] }
	stepMeta: {}, // { stepId: { totalCount, page, perPage, hasMore } }
	stepLoading: {}, // { stepId: boolean }
	stepFetched: {}, // { stepId: boolean } - tracks if step has been initially fetched
	stepRequestVersion: {}, // { stepId: number } - tracks request version to discard stale responses
	stepsRequestVersion: 0, // same guard for the step list itself, which is board-wide
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
